import { Component, OnInit } from '@angular/core';
import {SubscriptionsService} from '../../../services/subscriptions/subscriptions.service';
import {TranslateService} from '@ngx-translate/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'kt-subscriptions-error',
  templateUrl: './subscriptions-error.component.html',
  styleUrls: ['./subscriptions-error.component.scss']
})
export class SubscriptionsErrorComponent implements OnInit {
  userDevice = null;

  constructor(
    private subscriptions: SubscriptionsService,
    private translates: TranslateService,
    public dialogRef: MatDialogRef<SubscriptionsErrorComponent>
  ) { }

  ngOnInit(): void {
    this.userDevice = this.subscriptions.userDevice;
  }
  getSelectedLanguage() {
    return localStorage.getItem('language') || this.translates.getDefaultLang();
  }
  openSubscription(type: string) {
    if (type === 'month' && this.getSelectedLanguage() === 'de') {
      window.open('https://mindfield-shop.com/produkt/esense-eegenius-monatliche-software-nutzung-fuer-einen-account/', '_blank')
    }
    if (type === 'year' && this.getSelectedLanguage() === 'de') {
      window.open('https://mindfield-shop.com/produkt/esense-eegenius-jaehrliche-software-nutzung-fuer-einen-account/', '_blank')
    }
    if (type === 'month' && this.getSelectedLanguage() === 'en') {
      window.open('https://mindfield-shop.com/en/product/elementor-42416/', '_blank')
    }
    if (type === 'year' && this.getSelectedLanguage() === 'en') {
      window.open('https://mindfield-shop.com/en/product/esense-eegenius-annual-software-usage-for-one-account/', '_blank')
    }
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
